import Rules from '../model/rules';

/**
 * Rules service
 * @type {{init: (function()), getRulesSvc: (function())}}
 */
export const RulesSvc = {
  /**
   * Initialize rules service
   */
  init() {
    this.rulesSvc = new Rules();
  },

  /**
   * Get rules service
   * @returns {Rules| RulesSvc}
   */
  getRulesSvc() {
    return this.rulesSvc;
  },
};



// WEBPACK FOOTER //
// rules.service.js